import ProjectPlan from 'App/pages/ClientCard/ContentPages/ProjectPlan/ProjectPlan';

angular.module('domain.contact').controller('ContactProjectPlan', [
	'$scope',
	function ($scope: any) {
		$scope.ContactProjectPlan = ProjectPlan;
	}
]);
